module.exports = __webpack_public_path__ + "media/img/corporate/events2-a74270ab0d0375ffd912e9dd52ddb6bb.png";